import deepmerge from 'deepmerge'

export default {
  state: {
    defaults: {
      global: {
        dots: true,
        weekNumbers: true
      },
      work: {
        pin: null,
        filter: null,
        queue: false,
        zendesk: false,
        trello: true,
        jira: true,
        icons: true
      },
      cards: {
        labels: false
      }
    },
    settings: {}
  },
  getters: {
    settings: state => {
      return state.settings
    }
  },
  mutations: {
    SET_SETTINGS (state, settings) {
      state.settings = settings
      localStorage.setItem('settings', JSON.stringify(settings))
    }
  },
  actions: {
    LOAD_SETTINGS (context, settings) {
      context.commit('SET_SETTINGS', deepmerge(context.state.defaults, settings))
    },
    UPDATE_SETTINGS (context, { namespace, key, value }) {
      let setting = {
        [namespace]: {
          [key]: value
        }
      }
      context.commit('SET_SETTINGS', deepmerge(context.state.settings, setting))
    },
    RESET_SETTINGS (context, { namespace, key }) {
      let setting = {
        [namespace]: {
          [key]: context.state.defaults[namespace][key]
        }
      }
      context.commit('SET_SETTINGS', deepmerge(context.state.settings, setting))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/settings/index.js